/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from "react";
import LeftPanel from "../../../components/LeftPanel";
import Header from "../../../components/Header";
import styles from "../../../css/SetupForm.module.css";
import { v4 as uuidv4 } from "uuid";
import { openDB } from "idb";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { PlusIcon, UserGroupIcon, XIcon } from "@heroicons/react/solid";
import axios from "axios";
import DatePicker from "react-datepicker";
import JsPDF from "jspdf";
import { CancelRounded, Close, Notifications } from "@mui/icons-material";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import Context from "../../../context/context";
import schemeStyles from "../../../css/ReferenceScheme.module.css";
import CustomDropDown from "../../../components/CustomDropDown";
import spinner from "../../../images/spinner.svg";
import OptionsWrapper from "../../../components/OptionsWrapper";

const style = {
  popupContiner: {
    position: "absolute",
    background: "#00000052",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    zIndex: "1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  container: {
    padding: "25px",
    background: "white",
    boxShadow: "0 0 5px 0px black",
    borderRadius: "15px",
    fontSize: "25px",
    margin: "10px 10px 20px",
    alignItems: "center",
    maxHeight: "50%",
    position: "relative",
  },
  heading: {
    margin: "10px 5px 20px",
  },
  inputsContainer: {
    padding: "0 10px",
    overflow: "auto",
    width: "100%",
  },
  label: {
    padding: "8px",
    fontSize: "18px",
    borderRadius: "5px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  button: {
    marginTop: "20px",
    width: "fit-content",
  },
  close: {
    position: "absolute",
    right: "10px",
    top: "10px",
  },
};

const CustomersReports = () => {
  const [isItemAvilableOpen, setIsItemAvilableOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [CName, setCName] = useState("");
  const [CMobileNumber, setCMobileNumber] = useState("");
  const [paymentMode, setPaymentMode] = useState([]);
  const [popup, setPopup] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(null);
  const [customers_balances, setCustomers_balances] = useState([]);
  const [paymentModeDetails, setPaymentModeDetails] = useState([]);
  const [showBalance, setShowBalance] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState({});
  const [customerInfo, setCustomerInfo] = useState({});
  const [xlPopup, setXlPopup] = useState(false);
  const [paymentDetailPopup, setPaymentDetailPopup] = useState(false);
  const [customerGrp, setCustomerGrp] = useState(false);
  const [balanceFilter, setBalanceFilter] = useState("all");
  const [showBalanceNotificationPopup, setShowBalanceNotificationPopup] = useState(false)
  const fileExtension = ".xlsx";
  const context = useContext(Context);
  const { updateUnSync, showWarning } = context;
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  const printDocument = () => {
    const report = new JsPDF("landscape", "pt", "a4");
    report.html(document.getElementById("xlsTableToPrint")).then(() => {
      report.save("customer-report.pdf");
    });
  };
  async function getCustomersFromIDB(page, filter) {
    let skip = (+page - 1) * 200;

    let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);

    let store = db.transaction("customer", "readonly").objectStore("customer");
    let data = await store.getAll();
    data = await data.filter(
      (user) =>
        !showBalance ||
        balanceFilter === "all" ||
        paymentModeDetails?.filter(
          (p) =>
            customers_balances[p.payment_mode_uuid]?.find(
              (u) => u.customer_mobile === user.customer_mobile
            )?.customer_balance
        ).length
    )
    // console.log(countEvent, countEvent.target.result)
    let count = Math.ceil(data.length / 200);

    const pages = [];
    for (let i = 1; i <= count; i++) {
      pages.push(i);
    }
    // console.log(pages);
    setTotalPages(pages);
    data = data
      ?.filter(
        (a) =>
          !CMobileNumber ||
          a.customer_mobile
            .toLocaleLowerCase()
            .includes(CMobileNumber.toLocaleLowerCase())
      )
      ?.filter(
        (a) =>
          !CName ||
          a.outlet_wise_customer_details
            .find((b) => b.outlet_uuid === localStorage.getItem("outlet_uuid"))
            ?.customer_name.toLocaleLowerCase()
            .includes(CName.toLocaleLowerCase())
      )
      ?.sort((a, b) =>
        (+a.outlet_wise_customer_details[0].created_at || 0) < +b.outlet_wise_customer_details[0].created_at ? 1 : -1
      )

    console.log(data)
    setUsers(data.slice(skip, skip + 200));
  }

  const getDataFromIndexdDb = async () => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const paymentModes = await db
      .transaction("payment_modes", "readonly")
      .objectStore("payment_modes");
    let payModes = await paymentModes?.getAll();
    setPaymentModeDetails(
      payModes.filter((item) => item.maintain_customer_balance === "Y")
    );
    const payModeIds = [];
    const payModeName = [];
    payModes.forEach((i) => {
      if (i.maintain_customer_balance === "Y") {
        payModeIds.push(i.payment_mode_uuid);
        payModeName.push(i.payment_mode_name);
      }
    });

    setPaymentMode({
      ids: payModeIds,
      names: payModeName,
    });

    let response = await fetch(
      "https://api.myfooddo.com/customer/getCustomerBalance",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(payModeIds),
      }
    );
    response = await response.json();
    setCustomers_balances(response);
  };
  useEffect(() => {
    if (showBalance) getDataFromIndexdDb();
  }, [showBalance]);
  useEffect(() => {
    if (showBalance) getCustomersFromIDB(1, false);
  }, [customers_balances, balanceFilter]);

  useEffect(() => {
    // getDataFromIndexdDb();
    if (CMobileNumber || CName) getCustomersFromIDB(1, true);
    else getCustomersFromIDB(currentPage, false);
  }, [CName, CMobileNumber]);
  const downloadHandler = async (value) => {
    let sheetData = [];
    let userData = users;
    if (value === "all") {
      let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);

      let store = await db
        .transaction("customer", "readonly")
        .objectStore("customer");

      userData = await store.getAll();
    }
    userData = userData.filter(
      (user) =>
        balanceFilter === "all" ||
        paymentModeDetails?.filter(
          (p) =>
            customers_balances[p.payment_mode_uuid]?.find(
              (u) => u.customer_mobile === user.customer_mobile
            )?.customer_balance
        ).length
    );
    sheetData = userData.map((a) => {
      // console.log(a)
      let data = {
        Mobile: a.customer_mobile || "",
        Name: a.outlet_wise_customer_details[0].customer_name || "",
        Visits: a.outlet_wise_customer_details[0].customer_visits || 0,
      };
      if (showBalance)
        for (let p of paymentModeDetails) {
          data = {
            ...data,
            [p.payment_mode_name]:
              customers_balances[p.payment_mode_uuid]?.find(
                (u) => u.customer_mobile === a.customer_mobile
              )?.customer_balance || 0,
          };
        }
      return data;
    });
    const ws = XLSX.utils.json_to_sheet(sheetData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, "customer-sales-report" + fileExtension);
  };
  return (
    <>
      <LeftPanel
        setIsItemAvilableOpen={setIsItemAvilableOpen}
        isItemAvilableOpen={isItemAvilableOpen}
      />
      <Header />
      <div className="customer-reports-container orders-report-container">
        <div id="heading">
          <h2>Customers</h2>
        </div>
        <div className="filter-input-row" style={{ position: "relative", justifyContent: "space-between" }}>
          <div>
            <input
              className={styles.numberInput}
              type="number"
              name="invoice_title"
              value={CMobileNumber}
              onChange={(e) => {
                setCMobileNumber(e.target.value);
              }}
              placeholder="Search Mobile No."
              style={{ width: "40%" }}
            />

            <input
              className={styles.numberInput}
              type="text"
              name="invoice_heading"
              placeholder="Search Name"
              style={{ width: "40%" }}
              value={CName}
              onChange={(e) => {
                setCName(e.target.value);
              }}
            />

            {showBalance ? (
              <select
                className={styles.numberInput}
                type="text"
                name="invoice_heading"
                placeholder="Search Name"
                style={{ width: "40%" }}
                value={balanceFilter}
                onChange={(e) => {
                  setBalanceFilter(e.target.value);
                }}
              >
                <option value="all">All</option>
                <option value="bel">Balance Only</option>
              </select>
            ) : (
              ""
            )}
          </div>

          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "60px",
                right: "10vw",
                top: "50px",
              }}
            >
              <button
                className="hoverIcons"
                style={{ cursor: "pointer" }}
                onClick={() => setXlPopup(true)}
              >
                {/* <PictureAsPdf style={{ fontSize: "30px" }} /> */}
                Xls
              </button>
              <button
                className="hoverIcons"
                onClick={printDocument}
                style={{ cursor: "pointer" }}
              >
                {/* <PictureAsPdf style={{ fontSize: "30px" }} /> */}
                PDF
              </button>
            </div>

            <OptionsWrapper
              elements={<>
                <div onClick={() => setShowBalance(!showBalance)}>
                  <AccountBalanceWalletIcon id="balanceIco" />
                  <span>Check Balance</span>
                </div>
                <div onClick={() => setCustomerGrp((prev) => !prev)}>
                  <UserGroupIcon id="balanceIco" />
                  <span>Customer Groups</span>
                </div>
                <div onClick={() => setShowBalanceNotificationPopup(true)}>
                  <Notifications id="balanceIco" />
                  <span>Balance Notification</span>
                </div>
              </>}
            />
          </div>
        </div>

        <div className="table-container-user">
          <Table
            users={users}
            showBalance={showBalance}
            paymentMode={paymentMode}
            customers_balances={customers_balances}
            setPopup={setPopup}
            paymentModeDetails={paymentModeDetails}
            setPaymentInfo={setPaymentInfo}
            setPaymentDetailPopup={setPaymentDetailPopup}
            setCustomerInfo={setCustomerInfo}
          />
        </div>
      </div>
      {totalPages && totalPages[1] && (
        <div className="pagination">
          {/* <div>&laquo;</div> */}
          {totalPages.map((i) => (
            <div
              className={+currentPage === +i && "active"}
              onClick={(e) => {
                setCurrentPage(+i);
                getCustomersFromIDB(+i, false);
              }}
            >
              {i}
            </div>
          ))}
          {/* <div>&raquo;</div> */}
        </div>
      )}
      <div style={{ display: "none" }}>
        <table id="xlsTableToPrint">
          <thead id="tableHeadToPrint">
            <tr>
              <th
                colSpan={3 + (showBalance ? paymentMode?.names?.length : 0)}
                style={{ fontSize: "x-large" }}
              >
                {localStorage.getItem("outlet-name")}
              </th>
            </tr>

            <tr>
              <th>Mobile</th>
              <th>Name</th>
              <th>Visits</th>
              {showBalance && paymentMode?.names?.map((i) => <th>{i}</th>)}
            </tr>
          </thead>
          <tbody id="tableBodyToPrint" style={{ border: " solid black" }}>
            {users?.map((user) => (
              <tr key={Math.random()}>
                <td>{user?.customer_mobile || "-"}</td>
                <td>
                  {user?.outlet_wise_customer_details[0]?.customer_name || "-"}
                </td>
                <td>
                  {user?.outlet_wise_customer_details[0]?.customer_visits || 0}
                </td>
                {showBalance &&
                  paymentModeDetails?.map((p) => {
                    return (
                      <td
                        className="customer_balance_payment"
                        style={{ cursor: "pointer" }}
                      >
                        Rs.
                        {customers_balances[p.payment_mode_uuid]?.find(
                          (u) => u.customer_mobile === user.customer_mobile
                        )?.customer_balance || 0}
                      </td>
                    );
                  })}
              </tr>
            ))}
            <tr>
              <td
                colSpan={3 + (showBalance ? paymentMode?.names?.length : 0)}
              ></td>
            </tr>
            <tr>
              <td colSpan={3 + (showBalance ? paymentMode?.names?.length : 0)}>
                Generated using FoodDo at{" "}
                {sessionStorage
                  .getItem("date_format")
                  ?.replace(
                    "mm",
                    ("00" + (new Date()?.getMonth() + 1)?.toString())?.slice(-2)
                  )
                  ?.replace(
                    "yy",
                    ("0000" + new Date()?.getFullYear()?.toString())?.slice(-4)
                  )
                  ?.replace(
                    "dd",
                    ("00" + new Date()?.getDate()?.toString())?.slice(-2)
                  )}{" "}
                {new Date().toLocaleTimeString(navigator.language, {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {paymentDetailPopup ? (
        <CustomerPaymentPopup
          close={() => setPaymentDetailPopup(false)}
          popup={popup}
          paymentInfo={paymentInfo}
          customerInfo={customerInfo}
          updateUnSync={updateUnSync}
        />
      ) : (
        ""
      )}
      {xlPopup ? (
        <BrandSelectionPopUp
          close={() => setXlPopup(false)}
          downloadHandler={async (a) => {
            console.log(a);
            await downloadHandler(a);
            setXlPopup(false);
          }}
        />
      ) : (
        ""
      )}
      {customerGrp ? (
        <CustomerGroups
          onClose={() => setCustomerGrp(false)}
          updateUnSync={updateUnSync}
        />
      ) : (
        ""
      )}
      {showBalanceNotificationPopup ? <BalanceNotificationPopup
        showWarning={showWarning} close={() => setShowBalanceNotificationPopup(false)}
      /> : ''}
    </>
  );
};

export default CustomersReports;

function Table({
  users,
  setPaymentInfo,
  setPaymentDetailPopup,
  showBalance,
  paymentMode,
  setCustomerInfo,
  customers_balances,
  setPopup,
  paymentModeDetails,
}) {
  return (
    <table className="user-table">
      <thead>
        <tr>
          <th className="user-mobile">Mobile</th>
          <th className="user-name">Name</th>
          <th className="user-visits">Visits</th>
          <th className="user-address">Address</th>
          {showBalance &&
            paymentMode?.names?.map((i) => (
              <th className="user-balance">{i}</th>
            ))}
        </tr>
      </thead>
      <tbody>
        {users?.map((user) => (
          <tr key={Math.random()}>
            <td className="user-mobile">{user.customer_mobile || "-"}</td>
            <td className="user-name">
              {user?.outlet_wise_customer_details[0]?.customer_name || "-"}
            </td>
            <td className="user-visits">
              {user?.outlet_wise_customer_details[0]?.customer_visits || 0}
            </td>
            <td
              className="user-address"
              title={
                user.outlet_wise_customer_details[0]?.customer_outlet_address
              }
            >
              {user.outlet_wise_customer_details[0]?.customer_outlet_address?.slice(
                0,
                100
              ) || "-"}
            </td>
            {showBalance &&
              paymentModeDetails?.map((p) => {
                return (
                  <td
                    className="customer_balance_payment"
                    onClick={() => {
                      setPaymentInfo(p);
                      setCustomerInfo(user);
                      setPaymentDetailPopup(true);
                      setPopup({
                        customer_mobile: user.customer_mobile,
                        payment_mode_uuid: p.payment_mode_uuid,
                      });
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    Rs.
                    {customers_balances[p.payment_mode_uuid]?.find(
                      (u) => u.customer_mobile === user.customer_mobile
                    )?.customer_balance || 0}
                  </td>
                );
              })}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
const CustomerPaymentPopup = ({
  close,
  popup,
  customerInfo,
  paymentInfo,
  updateUnSync,
}) => {
  const [paymentPopup, setPaymentPopup] = useState(false);
  const [creditPopup, setCreditPopup] = useState(false);
  const [startDate, setStartDate] = useState(new Date().setHours(0, 0, 0, 0));
  const [endDate, setEndDate] = useState(new Date().setHours(23, 59, 59, 999));
  const [details, setDetails] = useState([]);

  const onSearch = async () => {
    const result = await axios({
      url: "https://api.myfooddo.com/customerTransaction/CustTransPaymentSummary",
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: [
        {
          start_date: startDate,
          end_date: endDate,
          outlet_uuid: localStorage.getItem("outlet_uuid"),
          payment_mode_uuid: paymentInfo.payment_mode_uuid,
          customer_mobile: customerInfo.customer_mobile,
        },
      ],
    });

    console.log(result.data.result);
    setDetails(result.data.result);
  };

  return (
    <>
      <div className="newCategory">
        <div
          className="newCatContainer"
          style={{
            width: "fit-content",
            height: "fit-content",
            minHeight: "500px",
          }}
        >
          <div className="newCatContainer_header">
            <h2>
              {paymentInfo?.payment_mode_name +
                " - " +
                customerInfo?.outlet_wise_customer_details[0]?.customer_name}
            </h2>
            <XIcon className="closeicon" onClick={close} />
          </div>
          <div
            className="newCatContainer2"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: "row",
              borderBottom: "2px solid black",
              padding: "5px 50px",
            }}
          >
            <button
              style={{
                fontSize: "15px",
                padding: "10px 20px",
                margin: "0",
              }}
              onClick={() => setPaymentPopup(true)}
            >
              Add Balance
            </button>
            <button
              style={{
                fontSize: "15px",
                padding: "10px 20px",
                margin: "0",
              }}
              onClick={() => setCreditPopup(true)}
            >
              Credit Limit
            </button>
          </div>
          <div
            className="newCatContainer2"
            style={{
              height: "fit-content",
              width: "fit-content",
            }}
          >
            <h2>Statement</h2>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  padding: "10px 0",
                  alignItems: "left",
                  justifyContent: "space-between",
                  flexDirection: "column",
                  width: "20%",
                }}
              >
                <label htmlFor="date-from" style={{ width: "100%" }}>
                  From date
                </label>
                <DatePicker
                  id="date-from"
                  selected={startDate}
                  dateFormat={sessionStorage.getItem("date_format").replace(/mm/, "MM")}
                  maxDate={new Date()}
                  onChange={date => setStartDate(new Date(date).setHours(0, 0, 0, 0))}
                  className="date-picker test"
                  wrapperClassName=""
                  shouldCloseOnSelect={true}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  padding: "10px 0",
                  alignItems: "left",
                  justifyContent: "space-between",
                  flexDirection: "column",
                  width: "20%",
                }}
              >
                <label style={{ width: "100%" }}>To date</label>
                <DatePicker
                  id="date-to"
                  selected={endDate}
                  dateFormat={sessionStorage
                    .getItem("date_format")
                    .replace(/mm/, "MM")}
                  maxDate={new Date()}
                  onChange={date => setEndDate(new Date(date).setHours(23, 59, 59, 999))}
                  className="date-picker test"
                  wrapperClassName=""
                  shouldCloseOnSelect={true}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "left",
                  flexDirection: "column",
                  height: "20px",
                }}
              >
                <button
                  style={{
                    border: "none",
                    padding: "10px 20px",
                    fontWeight: "bold",
                    color: "white",
                    backgroundColor: "black",
                    cursor: "pointer",
                  }}
                  onClick={onSearch}
                >
                  Filter
                </button>
              </div>
            </div>

            {details.length ? (
              <div className="itemavilablelitybox">
                <div className="items_table">
                  <table className="f6 w-100 center" cellSpacing="0">
                    <thead className="lh-copy">
                      <tr className="white">
                        <th className="pa3 bb b--black-20 ">S.NO.</th>
                        <th className="pa3 bb b--black-20 ">Date Time</th>
                        <th className="pa3 bb b--black-20 ">Narration</th>
                        <th className="pa3 bb b--black-20 ">Deducted</th>
                        <th className="pa3 bb b--black-20 ">Added</th>
                        <th className="pa3 bb b--black-20 ">Order Remarks</th>
                      </tr>
                    </thead>
                    <tbody className="lh-copy">
                      {details.map((a) => (
                        <tr>
                          <td
                            className="ph3 bb b--black-20 tc bg-white"
                            style={{ textAlign: "left", padding: "10px" }}
                          >
                            {a.sr_no}
                          </td>
                          <td
                            className="ph3 bb b--black-20 tc bg-white"
                            style={{ textAlign: "left", padding: "10px" }}
                          >
                            {/* {console.log(new Date(parseInt(a.date_time)))} */}
                            {sessionStorage
                              .getItem("date_format")
                              ?.replace(
                                "mm",
                                (
                                  "00" +
                                  (
                                    new Date(
                                      parseInt(a.date_time)
                                    )?.getMonth() + 1
                                  )?.toString()
                                )?.slice(-2)
                              )
                              ?.replace(
                                "yy",
                                (
                                  "0000" +
                                  new Date(parseInt(a.date_time))
                                    ?.getFullYear()
                                    ?.toString()
                                )?.slice(-4)
                              )
                              ?.replace(
                                "dd",
                                (
                                  "00" +
                                  new Date(parseInt(a.date_time))
                                    ?.getDate()
                                    ?.toString()
                                )?.slice(-2)
                              )}
                          </td>
                          <td
                            className="ph3 bb b--black-20 tc bg-white"
                            style={{ textAlign: "left", padding: "10px" }}
                          >
                            {a.narration}
                          </td>
                          <td
                            className="ph3 bb b--black-20 tc bg-white"
                            style={{ textAlign: "left", padding: "10px" }}
                          >
                            {(+a.deduced)?.toFixed(2)}
                          </td>
                          <td
                            className="ph3 bb b--black-20 tc bg-white"
                            style={{ textAlign: "left", padding: "10px" }}
                          >
                            {(+a.added)?.toFixed(2)}
                          </td>
                          <td
                            className="ph3 bb b--black-20 tc bg-white"
                            style={{ textAlign: "left", padding: "10px" }}
                          >
                            {a.order_remarks}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      {paymentPopup ? (
        <PaymentAddPopup
          parentClose={close}
          customer_mobile={popup.customer_mobile}
          payment_mode_uuid={popup.payment_mode_uuid}
          close={() => setPaymentPopup(false)}
        />
      ) : (
        ""
      )}
      {creditPopup ? (
        <CustomerCreditPopup
          customerInfo={customerInfo}
          close={() => {
            setCreditPopup(false);
            close();
          }}
          payment_mode_uuid={popup.payment_mode_uuid}
          updateUnSync={updateUnSync}
        />
      ) : (
        ""
      )}
    </>
  );
};
const PaymentAddPopup = ({
  close,
  payment_mode_uuid,
  customer_mobile,
  parentClose,
}) => {
  const [paymentModes, setPaymentModes] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  var payment_field_index = -1;
  useEffect(() => {
    const getData = async () => {
      const db = await openDB(
        "FoodDo",
        +localStorage.getItem("IDBVersion") || 1
      );
      const tx = await db
        .transaction("payment_modes", "readwrite")
        .objectStore("payment_modes");
      const payments = await tx.getAll();
      setPaymentModes(payments);
    };
    getData();
  });

  function setTotal() {
    setTimeout(() => {
      let total = 0;
      const inputs = document.getElementsByClassName("amount-field");
      Array.from(inputs).forEach((input) => {
        console.log(input);
        total = total + +input.value;
      });
      console.log("total", total);
      setTotalAmount(total);
    }, 100);
  }

  const paymentSaveHandle = async () => {
    let array = [];

    Array.from(document.getElementsByClassName("amount-field")).forEach(
      (field, i) => {
        if (+field.value > 0)
          array.push({
            payment_mode_uuid: field.getAttribute("payment-mode-uuid"),
            amount: +field.value,
          });
        else if (+totalAmount === 0 && +i === 0) {
          array.push({
            payment_mode_uuid: field.getAttribute("payment-mode-uuid"),
            amount: 0,
          });
        }
      }
    );

    let obj = {
      type: "R",
      narration: "Balance Added",
      reference_id: "",
      voucher_uuid: uuidv4(),
      payment_details: [{ payment_mode_uuid, amount: totalAmount }],
      customer_mobile,
      outlet_uuid: localStorage.getItem("outlet_uuid"),
      timestamp: Date.now(),
      paid_via: array,
      working_day: localStorage.getItem("current-working-day"),
    };
    console.log("payment", obj);
    const response = await axios({
      method: "post",
      url: "https://api.myfooddo.com/customerTransaction/postTransaction",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: [obj],
    });
    console.log("response", response);
    if (response.status === 200 && response.data?.result?.length === 1) {
      close();
    }
  };
  function clearField(e) {
    console.log(e.currentTarget.previousSibling);
    e.currentTarget.previousSibling.value = 0;
    setTotal();
  }

  return (
    <div className="paymentdiv" style={{ width: "100vw", zIndex: "999" }}>
      <div
        className="paymentContainer"
        style={{ width: "350px", minHeight: "fit-content" }}
      >
        <h1>Payment</h1>
        <XIcon onClick={close} className="closebtn" />
        <div className="div6" style={{ height: "fit-content" }}>
          <div className="paybils" style={{ height: "fit-content" }}>
            <div className="paycustomerdetails">
              <div className="bilReccit" style={{ width: "fit-content" }}>
                <div className="recitehead">
                  <h1>Mode Amount</h1>
                </div>
                <div className="flexitem">
                  {paymentModes &&
                    paymentModes?.map((mode, i) =>
                      mode.maintain_customer_balance === "N" ? (
                        <div key={i} className="recitebody">
                          <h1 className="paytct" style={{ width: "200px" }}>
                            {mode.payment_mode_name}
                          </h1>
                          <div>
                            <input
                              payment-field-index={++payment_field_index}
                              payment-mode-uuid={mode.payment_mode_uuid}
                              mode-name={mode.payment_mode_name}
                              className="amount-field"
                              type="number"
                              defaultValue={0}
                              onKeyDown={(e) => {
                                if (
                                  e.key === "ArrowUp" ||
                                  e.key === "ArrowDown" ||
                                  e.key === "e"
                                )
                                  e.preventDefault();
                              }}
                              style={{ width: "100px" }}
                              onChange={(e) => setTotal()}
                            />
                            <PlusIcon
                              className="field-cross"
                              onClick={(e) => clearField(e)}
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )
                    )}
                </div>
              </div>
            </div>
          </div>
          <div
            id="payment-btns-container"
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div className="paybilamountsBottomBtn" id="payment-total-btnDiv">
              <button className="orange">Total : Rs.{totalAmount}</button>
            </div>
            <div
              className="paybilamountsBottomBtn"
              id="payment-btnDiv"

            // ref={payment_popup_save_btns_ref}
            >
              {/* <button
                                className="redbtn"
                                id="payment-cancel-btn"
                                onClick={close}
                            >
                                Cancel
                            </button> */}
              <button
                id="save-and-payment-btn"
                className="greenbtn"
                onClick={paymentSaveHandle}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const CustomerCreditPopup = ({
  close,
  customerInfo,
  updateUnSync,
  payment_mode_uuid,
}) => {
  const [paymentModes, setPaymentModes] = useState({});
  const [customerData, setCustomerData] = useState({});

  var payment_field_index = -1;
  useEffect(() => {
    const getData = async () => {
      const db = await openDB(
        "FoodDo",
        +localStorage.getItem("IDBVersion") || 1
      );
      const tx = await db
        .transaction("payment_modes", "readwrite")
        .objectStore("payment_modes");
      let payments = await tx.get(payment_mode_uuid);
      setPaymentModes(payments);
    };
    getData();
  }, []);
  useEffect(() => {
    const getData = async () => {
      const response = await axios({
        method: "post",
        url: "https://api.myfooddo.com/customer/getCustomer",
        // url: "http://localhost:5001/customer/getCustomer",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: [{ customer_mobile: customerInfo.customer_mobile }],
      });
      setCustomerData(response.data[0])
    };
    getData()

  }, [customerInfo]);

  const handleReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const seatsJsonExists = allReconRecords?.find(
      (curr) => curr.IDENTIFIER === "customer"
    );
    if (seatsJsonExists) {
      const seats = seatsJsonExists?.details?.filter(
        (seat) => seat.customer_mobile !== data.customer_mobile
      );
      const editData = {
        ...seatsJsonExists,
        details: [
          ...seats,
          {
            customer_mobile: data.customer_mobile,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "customer",
        details: [
          {
            customer_mobile: data.customer_mobile,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }
    db.close();
  };
  const handleEditCustomerUnsynced = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const ndata = {
      ...data,
      RECON_TIME: Date.now(),
      IDENTIFIER: "customer-edit:" + data.customer_mobile,
    };
    await tx.put(ndata);
    handleReconciliation(ndata);
    updateUnSync();
    db.close();
    close();
  };
  const handleEditCustomer = async () => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const indSeats = await db
      .transaction("customer", "readwrite")
      .objectStore("customer");
    const tx = await indSeats.get(`${customerData.customer_mobile}`);

    const data = {
      ...(tx || {}),
      customer_payment_details: customerData.customer_payment_details,
    };
    await indSeats.put(data);
    handleEditCustomerUnsynced(data);
    db.close();
  };
  console.log(customerData)
  return (
    <div className="paymentdiv" style={{ width: "100vw", zIndex: "999" }}>
      <div
        className="paymentContainer"
        style={{ width: "350px", minHeight: "fit-content" }}
      >
        <h1>Credit Amount</h1>
        <XIcon onClick={close} className="closebtn" />
        <div className="div6" style={{ height: "fit-content" }}>
          <div className="paybils" style={{ height: "fit-content" }}>
            <div className="paycustomerdetails">
              <div className="bilReccit" style={{ width: "fit-content" }}>
                <div className="recitehead"></div>
                <div className="flexitem">
                  <div className="recitebody">
                    <h1 className="paytct" style={{ width: "200px" }}>
                      {paymentModes?.payment_mode_name}
                    </h1>
                    <div>
                      <input
                        payment-field-index={++payment_field_index}
                        payment-mode-uuid={paymentModes?.payment_mode_uuid}
                        mode-name={paymentModes?.payment_mode_name}
                        className="amount-field"
                        type="number"
                        defaultValue={0}
                        onKeyDown={(e) => {
                          if (
                            e.key === "ArrowUp" ||
                            e.key === "ArrowDown" ||
                            e.key === "e"
                          )
                            e.preventDefault();
                        }}
                        style={{ width: "100px" }}
                        value={
                          customerData.customer_payment_details?.find(
                            (a) =>
                              a.payment_mode_uuid ===
                              paymentModes?.payment_mode_uuid
                          )?.credit_limit
                        }
                        onChange={(e) =>
                          setCustomerData((prev) =>
                            prev.customer_payment_details?.filter(
                              (a) =>
                                a.payment_mode_uuid ===
                                paymentModes?.payment_mode_uuid
                            ).length
                              ? {
                                ...prev,
                                customer_payment_details:
                                  prev.customer_payment_details?.map((a) =>
                                    a.payment_mode_uuid ===
                                      paymentModes?.payment_mode_uuid
                                      ? {
                                        ...a,
                                        credit_limit: e.target.value,
                                      }
                                      : a
                                  ),
                              }
                              : {
                                ...prev,
                                customer_payment_details: [
                                  ...prev.customer_payment_details,

                                  {
                                    credit_limit: e.target.value,
                                    payment_mode_uuid:
                                      paymentModes?.payment_mode_uuid,
                                  },
                                ],
                              }
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="payment-btns-container"
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div className="paybilamountsBottomBtn" id="payment-btnDiv">
              <button
                id="save-and-payment-btn"
                className="greenbtn"
                onClick={handleEditCustomer}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const BrandSelectionPopUp = ({ close, downloadHandler }) => {
  const [selectedBrand, setSelectedBrand] = useState("curr");

  return (
    <div style={style.popupContiner}>
      <div className="form" style={style.container}>
        <h3 style={style.heading}>Brand Selection</h3>
        <div style={style.inputsContainer}>
          <label htmlFor={"curr"} style={style.label}>
            <input
              id={"curr"}
              type="radio"
              name="brand-selection"
              defaultChecked={selectedBrand === "curr"}
              onChange={(e) => e.target.checked && setSelectedBrand("curr")}
            />
            Current Page
          </label>
          <label htmlFor={"all"} style={style.label}>
            <input
              id={"all"}
              type="radio"
              name="brand-selection"
              defaultChecked={selectedBrand === "all"}
              onChange={(e) => e.target.checked && setSelectedBrand("all")}
            />
            All Page
          </label>
        </div>
        <button
          type="button"
          className="submit"
          onClick={(e) => downloadHandler(selectedBrand)}
          style={style.button}
        >
          Select
        </button>
        <CancelRounded onClick={close} style={style.close} />
      </div>
    </div>
  );
};
const CustomerGroups = ({ onClose, updateUnSync }) => {
  const [newGrpPopup, setNewGrpPopup] = useState(false);
  const [selectedGroupData, setSelectedGroup] = useState("");
  const [CustomerGroupsList, setCustomerGrpList] = useState([]);
  const [itemPopup, setItemPopup] = useState(false);
  const [customerPopup, setCustomerPopup] = useState(false);
  const handleAddCustomerGroup = async () => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const indSeats = await db
      .transaction("customer_groups", "readwrite")
      .objectStore("customer_groups");
    const id = uuidv4();
    const data = {
      IDENTIFIER: id,
      customer_group_uuid: id,
      customer_group_title: selectedGroupData.customer_group_title,
      outlet_uuid: [localStorage.getItem("outlet_uuid")],
    };
    await indSeats.put(data);
    handleAddSeatUnsynced(data);
    onClose();
  };
  const getData = async () => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const indSeats = await db
      .transaction("customer_groups", "readwrite")
      .objectStore("customer_groups");
    let data = await indSeats.getAll();
    setCustomerGrpList(data || []);
  };
  useEffect(() => {
    getData();
  }, []);
  const handleAddSeatUnsynced = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const ndata = {
      ...data,
      RECON_TIME: Date.now(),
      IDENTIFIER: "customer_group-new:" + data.customer_group_uuid,
    };
    await tx.put(ndata);
    handleReconciliation(ndata);
    updateUnSync();
    onClose();
  };
  const handleReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const seatsJsonExists = allReconRecords?.find(
      (curr) => curr.IDENTIFIER === "customer_group"
    );
    if (seatsJsonExists) {
      const seats = seatsJsonExists?.details?.filter(
        (seat) => seat.customer_group_uuid !== data.customer_group_uuid
      );
      const editData = {
        ...seatsJsonExists,
        details: [
          ...seats,
          {
            customer_group_uuid: data.customer_group_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "customer_group",
        details: [
          {
            customer_group_uuid: data.customer_group_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }
  };
  const handleEditSeatUnsynced = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const ndata = {
      ...data,
      RECON_TIME: Date.now(),
      IDENTIFIER: "customer_group-edit:" + data.customer_mobile,
    };
    await tx.put(ndata);
    handleReconciliation(ndata);
    updateUnSync();
  };
  const handleEditSeat = async (value) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const indSeats = await db
      .transaction("customer_groups", "readwrite")
      .objectStore("customer_groups");
    const tx = await indSeats.get(`${value.customer_group_uuid}`);

    const data = {
      ...(tx || {}),
      customer_group_title: value.customer_group_title,
      customer_group_uuid: value.customer_group_uuid,
      special_prices: value.special_prices,
    };
    await indSeats.put(data);
    handleEditSeatUnsynced(data);
    onClose();
  };
  return (
    <>
      <div className="itemavilablelity" style={{ left: "0" }}>
        <div className="itemavilabelitycontainer" style={{ width: "60vw" }}>
          <div className="itemavilablelity_header">
            <h2>Customer Groups</h2>
            <Close onClick={onClose} />
          </div>
          <div onClick={() => setNewGrpPopup(true)}>
            <button className="savebtn">Add Groups</button>
          </div>
          <div className="availablecontainer">
            <div className="itemavilablelitybox">
              {/* <input
                className={styles.numberInput}
                type="text"
                name="item_filter"
                // value={itemFilter}
                // onChange={(e) => { setItemFilter(e.target.value); }}
                placeholder="Items Filter"
                style={{ width: "80%", margin: "10px 0" }}
              /> */}
              <div className="items_table" style={{ width: "50vw" }}>
                <table className="f6 w-100 center" cellSpacing="0">
                  <thead className="lh-copy">
                    <tr className="white">
                      <th className="pa3 bb b--black-20 ">Item</th>
                      <th className="pa3 bb b--black-20 " colSpan={2}>
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="lh-copy">
                    {CustomerGroupsList.map((item, index) => (
                      <tr key={index}>
                        <td className="ph3 bb b--black-20 tc bg-white">
                          {item.customer_group_title}
                        </td>

                        <td
                          className="ph3 bb b--black-20 tc bg-white"
                          style={{ padding: "10px 0" }}
                        >
                          <button
                            type="button"
                            style={{ fontSize: "10px" }}
                            className="fieldEditButton"
                            onClick={(e) => {
                              e.stopPropagation();
                              setItemPopup(item);
                            }}
                          >
                            Item Special Prices
                          </button>
                        </td>
                        <td
                          className="ph3 bb b--black-20 tc bg-white"
                          style={{ padding: "10px 0" }}
                        >
                          <button
                            type="button"
                            style={{ fontSize: "10px" }}
                            className="fieldEditButton"
                            onClick={(e) => {
                              e.stopPropagation();
                              setCustomerPopup(item);
                            }}
                          >
                            Customers
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {newGrpPopup ? (
        <div className="itemavilablelity" style={{ left: "0" }}>
          <div className="itemavilabelitycontainer" style={{ width: "400px" }}>
            <div className="itemavilablelity_header">
              <h2>Customer Groups</h2>
              <Close onClick={() => setNewGrpPopup(false)} />
            </div>

            <div className="availablecontainer">
              <div className="itemavilablelitybox">
                <input
                  className={styles.numberInput}
                  type="text"
                  name="item_filter"
                  value={selectedGroupData?.customer_group_title || ""}
                  onChange={(e) => {
                    setSelectedGroup((prev) => ({
                      ...prev,
                      customer_group_title: e.target.value,
                    }));
                  }}
                  placeholder="Title"
                  style={{ width: "80%", margin: "10px 0" }}
                />
              </div>
            </div>
            <div onClick={handleAddCustomerGroup}>
              <button className="savebtn">Done</button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      {itemPopup ? (
        <ItemPopup
          onSave={() => setItemPopup(false)}
          itemPopup={itemPopup}
          updateCustomerGroup={handleEditSeat}
        />
      ) : (
        ""
      )}
      {customerPopup ? (
        <CustomerGroupsPopup
          onSave={() => setCustomerPopup(false)}
          customerPopup={customerPopup}
          updateUnSync={updateUnSync}
        // updateCustomerGroup={handleEditSeat}
        />
      ) : (
        ""
      )}
    </>
  );
};
const CustomerGroupsPopup = ({ onSave, customerPopup, updateUnSync }) => {
  let outlet_uuid = localStorage.getItem("outlet_uuid");
  const [itemsData, setItemsData] = useState([]);
  const getData = async () => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const indSeats = await db
      .transaction("customer", "readwrite")
      .objectStore("customer");
    let data = await indSeats.getAll();
    setItemsData(data || []);
  };

  useEffect(() => {
    getData();
  }, []);

  const getItemsData = async () => { };
  useEffect(() => {
    getItemsData();
  }, []);

  const submitHandler = async () => {
    let items = itemsData.filter((a) => a.edit);
    for (let data of items) {
      handleEditCustomer(data);
    }
    onSave();
  };
  const handleReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const seatsJsonExists = allReconRecords?.find(
      (curr) => curr.IDENTIFIER === "customer"
    );
    if (seatsJsonExists) {
      const seats = seatsJsonExists?.details?.filter(
        (seat) => seat.customer_mobile !== data.customer_mobile
      );
      const editData = {
        ...seatsJsonExists,
        details: [
          ...seats,
          {
            customer_mobile: data.customer_mobile,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "customer",
        details: [
          {
            customer_mobile: data.customer_mobile,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }
    db.close();
  };
  const handleEditCustomerUnsynced = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const ndata = {
      ...data,
      RECON_TIME: Date.now(),
      IDENTIFIER: "customer-edit:" + data.customer_mobile,
    };
    await tx.put(ndata);
    handleReconciliation(ndata);
    updateUnSync();
    db.close();
  };
  const handleEditCustomer = async (value) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const indSeats = await db
      .transaction("customer", "readwrite")
      .objectStore("customer");
    const tx = await indSeats.get(`${value.customer_mobile}`);

    const data = {
      ...(tx || {}),
      customer_mobile: value.customer_mobile,
      outlet_wise_customer_details: value.outlet_wise_customer_details,
    };
    await indSeats.put(data);
    handleEditCustomerUnsynced(data);
    db.close();
  };
  return (
    <div className="itemavilablelity" style={{ left: "0" }}>
      <div className="itemavilabelitycontainer" style={{ width: "60vw" }}>
        <div className="itemavilablelity_header">
          <h2>Group Customers</h2>
          <Close onClick={onSave} />
        </div>
        <div className="availablecontainer">
          <div className="itemavilablelitybox">
            <div className="items_table" style={{ width: "50vw" }}>
              <table className="f6 w-100 center" cellSpacing="0">
                <thead className="lh-copy">
                  <tr className="white">
                    <th className="pa3 bb b--black-20 "></th>
                    <th className="pa3 bb b--black-20 " colSpan={2}>
                      Customer
                    </th>

                    <th className="pa3 bb b--black-20 " colSpan={2}>
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody className="lh-copy">
                  {itemsData
                    ?.filter((a) => a.customer_mobile)

                    .map((item, index) => {
                      return (
                        <tr key={item.item_uuid}>
                          <td className="ph3 bb b--black-20 tc bg-white">
                            {index + 1}
                          </td>
                          <td className="ph3 bb b--black-20 tc bg-white">
                            {item.outlet_wise_customer_details?.find(
                              (a) => a.outlet_uuid === outlet_uuid
                            )?.customer_name || ""}
                          </td>
                          <td className="ph3 bb b--black-20 tc bg-white">
                            {item.customer_mobile}
                          </td>
                          <td className="ph3 bb b--black-20 tc bg-white">
                            <button
                              type="button"
                              className="noBgActionButton"
                              style={{
                                backgroundColor:
                                  item?.outlet_wise_customer_details
                                    ?.find((a) => a.outlet_uuid === outlet_uuid)
                                    ?.customer_groups?.filter(
                                      (a) =>
                                        a === customerPopup?.customer_group_uuid
                                    ).length
                                    ? "red"
                                    : "var(--mainColor)",
                                width: "150px",
                                fontSize: "large",
                              }}
                              onClick={(event) =>
                                setItemsData((prev) =>
                                  item?.outlet_wise_customer_details
                                    .find((a) => a?.outlet_uuid === outlet_uuid)
                                    ?.customer_groups?.filter(
                                      (a) =>
                                        a === customerPopup?.customer_group_uuid
                                    )?.length
                                    ? prev.map((a) =>
                                      a.customer_mobile ===
                                        item.customer_mobile
                                        ? {
                                          ...item,
                                          edit: true,
                                          outlet_wise_customer_details:
                                            item.outlet_wise_customer_details.map(
                                              (b) =>
                                                b.outlet_uuid ===
                                                  outlet_uuid
                                                  ? {
                                                    ...b,
                                                    customer_groups:
                                                      b?.customer_groups.filter(
                                                        (a) =>
                                                          a !==
                                                          customerPopup.customer_group_uuid
                                                      ),
                                                  }
                                                  : b
                                            ),
                                        }
                                        : a
                                    )
                                    : prev.map((a) =>
                                      a.customer_mobile ===
                                        item.customer_mobile
                                        ? {
                                          ...item,
                                          edit: true,
                                          outlet_wise_customer_details:
                                            item.outlet_wise_customer_details.map(
                                              (b) =>
                                                b.outlet_uuid ===
                                                  outlet_uuid
                                                  ? {
                                                    ...b,
                                                    customer_groups: b
                                                      ?.customer_groups
                                                      ?.length
                                                      ? [
                                                        ...b.customer_groups,
                                                        customerPopup.customer_group_uuid,
                                                      ]
                                                      : [
                                                        customerPopup.customer_group_uuid,
                                                      ],
                                                  }
                                                  : b
                                            ),
                                        }
                                        : a
                                    )
                                )
                              }
                            >
                              {item?.outlet_wise_customer_details
                                ?.find((a) => a?.outlet_uuid === outlet_uuid)
                                ?.customer_groups?.filter(
                                  (a) =>
                                    a === customerPopup?.customer_group_uuid
                                )?.length
                                ? "Remove"
                                : "Add"}
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <button className="fieldEditButton" onClick={submitHandler}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};
const ItemPopup = ({ onSave, itemPopup, updateCustomerGroup }) => {
  const [itemsData, setItemsData] = useState([]);

  const [value, setValue] = useState([]);

  const getData = async () => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const indSeats = await db
      .transaction("item", "readwrite")
      .objectStore("item");
    let data = await indSeats.getAll();
    setItemsData(data || []);
  };

  useEffect(() => {
    setValue(itemPopup?.special_prices || []);
    getData();
  }, []);

  const getItemsData = async () => { };
  useEffect(() => {
    getItemsData();
  }, []);

  const submitHandler = async () => {
    updateCustomerGroup({ ...itemPopup, special_prices: value });
    onSave();
  };
  return (
    <div className="itemavilablelity" style={{ left: "0" }}>
      <div className="itemavilabelitycontainer" style={{ width: "60vw" }}>
        <div className="itemavilablelity_header">
          <h2>Group Items</h2>
          <Close onClick={onSave} />
        </div>
        <div className="availablecontainer">
          <div className="itemavilablelitybox">
            <div className="items_table" style={{ width: "50vw" }}>
              <table className="f6 w-100 center" cellSpacing="0">
                <thead className="lh-copy">
                  <tr className="white">
                    <th className="pa3 bb b--black-20 " colSpan={2}>
                      Item
                    </th>

                    <th className="pa3 bb b--black-20 " colSpan={3}>
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody className="lh-copy">
                  {itemsData
                    ?.filter((a) => a.item_uuid)

                    .map((item, index) => {
                      return (
                        <tr key={item.item_uuid}>
                          <td
                            className="ph3 bb b--black-20 tc bg-white"
                            colSpan={2}
                          >
                            {item.item_name}
                          </td>
                          <td className="ph3 bb b--black-20 tc bg-white">
                            <button
                              type="button"
                              className="noBgActionButton"
                              style={{
                                backgroundColor: value.filter(
                                  (a) => a.item_uuid === item.item_uuid
                                )?.length
                                  ? "red"
                                  : "var(--mainColor)",
                                width: "150px",
                                fontSize: "large",
                              }}
                              onClick={(event) =>
                                setValue((prev) =>
                                  value.filter(
                                    (a) => a.item_uuid === item.item_uuid
                                  )?.length
                                    ? value.filter(
                                      (a) => a.item_uuid !== item.item_uuid
                                    )
                                    : prev.length
                                      ? [...prev, { item_uuid: item.item_uuid }]
                                      : [{ item_uuid: item.item_uuid }]
                                )
                              }
                            >
                              {value.filter(
                                (a) => a.item_uuid === item.item_uuid
                              )?.length
                                ? "Remove"
                                : "Add"}
                            </button>
                          </td>
                          <td className="ph3 bb b--black-20 tc bg-white">
                            <input
                              type="number"
                              onWheel={(e) => e.target.blur()}
                              style={{
                                width: "80px",
                                padding: "10px",
                                backgroundColor: value.filter(
                                  (a) => a.item_uuid === item.item_uuid
                                )?.length
                                  ? "gray"
                                  : "#fff",
                              }}
                              onChange={(e) =>
                                setValue((prev) =>
                                  prev.map((a) =>
                                    a.item_uuid === item.item_uuid
                                      ? {
                                        ...a,
                                        price: e.target.value,
                                      }
                                      : a
                                  )
                                )
                              }
                              value={
                                value.find(
                                  (a) => a.item_uuid === item.item_uuid
                                )?.price
                              }
                              placeholder={"price..."}
                              className="searchInput"
                              disabled={
                                !value.filter(
                                  (a) => a.item_uuid === item.item_uuid
                                )?.length
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <button className="fieldEditButton" onClick={submitHandler}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};
const notificationUsersOptions = [
  { value: '0', label: 'All' },
  { value: '1', label: 'Balance Only' },
  { value: '2', label: 'Only Negative Balance' }
]
const BalanceNotificationPopup = ({ showWarning, close }) => {

  const onSave = async () => {
    try {
      setLoadingState(true)
      const response = await axios({
        method: "post",
        // url: "http://localhost:5000/customer/balance-notification",
        url: "https://api.myfooddo.com/customer/balance-notification",
        headers: { "Content-Type": "application/json" },
        data: {
          send_payment_link: paymentLinkBoolean,
          selected_customer_type: `${notificationOptions?.selected}`,
          outlet_uuid: localStorage.getItem("outlet_uuid")
        },
      })

      console.log({ response })
      if (response?.data?.success) {
        showWarning({
          message: `${response?.data?.sentMessageCount} Messages Sent.`,
          classname: 'active-green'
        })

        if (+response?.data?.remaining_sms_balance < 30)
          setTimeout(() => showWarning({
            message: `${response?.data?.remaining_sms_balance} SMS Credits Remaining`,
            classname: 'active-orange'
          }), 2000);

        let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        let outletStore = db.transaction("outlet", "readwrite").objectStore("outlet");
        let outlet = (await outletStore.getAll())?.[0];
        await outletStore.put({ ...outlet, sms_balance: +response?.data?.remaining_sms_balance })
      }
      setLoadingState(false)
      close()
    } catch (error) {
      setLoadingState(false)
      const err = error?.response?.data
      if (err?.message) showWarning({
        message: err?.message,
        classname: 'active-red'
      })
    }
  }

  const [notificationOptions, setNotificationOptions] = useState({ selected: '2', visible: false, options: notificationUsersOptions })
  const [paymentLinkBoolean, setPaymentLinkBoolean] = useState(true)
  const [loadingState, setLoadingState] = useState(false)

  return (
    <div className={schemeStyles.popupContainer}>
      <div className={schemeStyles.popupBody}>
        <h2>Balance Notification</h2>
        <div>
          <div className={schemeStyles.formsContainer} style={{ overflow: 'visible' }}>
            <CustomDropDown
              label={'Customers'}
              state={notificationOptions}
              setState={setNotificationOptions}
              onSelect={value => setNotificationOptions(doc => ({ ...doc, selected: value }))}
              styles={{ container: { position: 'unset', margin: '7px 0', gap: '20px', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-betweeen' } }}
            />
            <label htmlFor="payment-link-input">
              Send Payment Link For Negative Balance
              <input type="checkbox" id="payment-link-input" onChange={e => setPaymentLinkBoolean(e.target.checked)} checked={paymentLinkBoolean} style={{ marginLeft: '10px' }} />
            </label>
          </div>
          <button
            className={schemeStyles.submitBtn}
            style={{ padding: '8px', width: '100%' }}
            onClick={onSave}
          >Send</button>
        </div>
        <CancelRounded className={schemeStyles.close} onClick={close} />
        {loadingState ? <span className={styles.loadingDiv}><img src={spinner} alt="loading reports" /></span> : ''}
      </div>
    </div>
  )
}